/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".newItem_e3a39afc{color:"},{"theme":"green","defaultValue":"#107c10"},{"rawString":";margin-right:3px}\n"}]);
export const newItem = "newItem_e3a39afc";